// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablaComparacionVentasDeVendedoresDelClientePorArticulo__SorteableHeaderTitle__lfAyE:hover {\r\n  color: rgba(0, 0, 0, 0.54);\r\n  cursor: pointer;\r\n}\r\n\r\n.TablaComparacionVentasDeVendedoresDelClientePorArticulo__TablasComparacionComprobantesContainer__t8Wxn {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SorteableHeaderTitle": "TablaComparacionVentasDeVendedoresDelClientePorArticulo__SorteableHeaderTitle__lfAyE",
	"TablasComparacionComprobantesContainer": "TablaComparacionVentasDeVendedoresDelClientePorArticulo__TablasComparacionComprobantesContainer__t8Wxn"
};
export default ___CSS_LOADER_EXPORT___;
